export const getPlural = (
  count: number | undefined = 0,
  singular: string,
  plural?: string,
) => `${count} ${count === 1 ? singular : plural ?? `${singular}s`}`;
